import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import bus from "../src/components/common/bus.js"
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import "./assets/scss/commen.scss";
import "./assets/css/public.css";
import './components/common/directives';
import 'babel-polyfill';
import api from "./api/axios";
import echarts from 'echarts'
import tableHeight from './js/resize'

//引用echarts地图配置
// require('echarts/extension/bmap/bmap');
import {
    isCtrlPress,
    isCommand
} from '../src/components/common/keyboard';
import vDropdown from './components/common/dropdown/dropdown.vue'
 import { VueOkrTree } from "vue-okr-tree";
 import "vue-okr-tree/dist/vue-okr-tree.css";
 Vue.component('vue-okr-tree', VueOkrTree) //全局注册组件，也可局部使用注册
Vue.component('vDropdown', vDropdown);


Vue.prototype.$echarts = echarts;
Vue.prototype.$tableHeight = tableHeight;
Vue.prototype.$bus = bus;
Vue.prototype.$api = api;
import "./js/dialog"; //弹窗拖拽
import "./js/scroll"; //列表监听
Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    // 在每次路由跳转的时候进行判断
    if (isCtrlPress() || isCommand()) {
        // 如果 ctrl 按键被按下，则以新窗口打开目标页面
        window.open('#' + to.fullPath)
        // 并阻止当前页面的跳转
        return next(false)
    } else {
        if (to.query.type) {
            if (to.query.type == '1' || to.query.type == 'update') {
                document.title = to.meta.title + '编辑'
            } else {
                document.title = to.meta.title + '新增'
            }
        } else {
            document.title = to.meta.title
        }
        return next()
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
